/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const HeaderButtonProvider = (props) => {
    const [state, setState] = useState({});
    return React.createElement(Provider, { value: { state, setState } }, props.children);
};
function useHeaderButton() {
    const HeaderButtonContext = useContext(store);
    const showHeaderButton = (button) => {
        HeaderButtonContext.setState(Object.assign(Object.assign({}, HeaderButtonContext.state), { button: button, show: true }));
    };
    const hideHeaderButton = () => {
        HeaderButtonContext.setState(Object.assign(Object.assign({}, HeaderButtonContext.state), { show: true }));
    };
    return {
        showHeaderButton: showHeaderButton,
        hideHeaderButton: hideHeaderButton,
        show: HeaderButtonContext.state.show,
        button: HeaderButtonContext.state.button
    };
}
export { store as HeaderButtonStore, HeaderButtonProvider, useHeaderButton };
//# sourceMappingURL=index.js.map